import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const s = {
  page: { minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '2rem', gap: '1.5rem' },
  header: { display: 'flex', alignItems: 'center', gap: '1rem', width: '100%', maxWidth: '600px' },
  back: { background: 'rgba(255,255,255,0.1)', color: 'white', borderRadius: '12px', padding: '0.5rem 1rem', fontSize: '1.2rem', border: 'none', cursor: 'pointer' },
  xpRow: { display: 'flex', gap: '1rem', fontSize: '0.85rem', color: 'var(--text-muted)', fontWeight: 700 },
  card: { background: 'rgba(13,27,42,0.8)', border: '2px solid rgba(0,212,255,0.2)', borderRadius: '24px', padding: '2.5rem', width: '100%', maxWidth: '600px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2rem' },
  question: { fontSize: 'clamp(2.5rem, 8vw, 4.5rem)', fontFamily: 'Nunito, sans-serif', fontWeight: 900, letterSpacing: '2px', color: 'var(--accent)', textAlign: 'center', textShadow: '0 0 20px rgba(249,199,79,0.5)' },
  input: { background: 'rgba(0,0,0,0.3)', border: '2px solid rgba(0,212,255,0.3)', borderRadius: '16px', padding: '1rem 1.5rem', fontSize: '2rem', color: 'white', textAlign: 'center', width: '160px', outline: 'none' },
  checkBtn: { background: 'var(--accent)', color: '#060b14', borderRadius: '16px', padding: '1rem 2rem', fontSize: '1.2rem', fontWeight: 900, border: 'none', cursor: 'pointer' },
  hintBtn: { background: 'rgba(0,212,255,0.1)', border: '2px solid var(--blue)', color: 'var(--blue)', borderRadius: '12px', padding: '0.6rem 1.2rem', fontSize: '0.9rem', fontWeight: 800 },
  nextBtn: { background: 'var(--green)', color: '#060b14', borderRadius: '16px', padding: '1rem 2.5rem', fontSize: '1.2rem', fontWeight: 900, border: 'none', cursor: 'pointer' },
  hintBox: { background: 'rgba(0,212,255,0.05)', border: '2px solid var(--blue)', borderRadius: '20px', padding: '1.5rem', width: '100%' },
  grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' },
  gridCell: { background: 'rgba(0,0,0,0.3)', borderRadius: '12px', padding: '0.75rem', textAlign: 'center' },
  xpFloat: { position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', fontSize: '3rem', fontFamily: 'Bangers, cursive', color: 'var(--accent)', pointerEvents: 'none', animation: 'xpPop 1s ease forwards', zIndex: 9999 },
  diffTabs: { display: 'flex', gap: '0.75rem', background: 'rgba(0,0,0,0.3)', padding: '0.5rem', borderRadius: '16px' },
};

export default function Matematik({ user, name, age }) {
  const navigate = useNavigate();
  const [question, setQuestion] = useState(null);
  const [answer, setAnswer] = useState('');
  const [feedback, setFeedback] = useState(null);
  const [showHint, setShowHint] = useState(false);
  const [xp, setXp] = useState({ today: 0, week: 0, year: 0 });
  const [streak, setStreak] = useState(0);
  const [showXpFloat, setShowXpFloat] = useState(false);
  const [xpGained, setXpGained] = useState(0);
  const [difficulty, setDifficulty] = useState('simpel');
  const inputRef = useRef();

  useEffect(() => {
    fetch('/api/xp/'+user).then(r => r.json()).then(d => setXp(d.matematik || { today: 0, week: 0, year: 0 })).catch(() => {});
    loadQuestion();
  }, [user]);

  useEffect(() => { loadQuestion(); }, [difficulty]);

  const loadQuestion = () => {
    setFeedback(null);
    setAnswer('');
    setShowHint(false);
    let a, b;
    if (difficulty === 'simpel') {
      a = Math.floor(Math.random() * 9) + 2;
      b = Math.floor(Math.random() * 90) + 10;
    } else {
      a = Math.floor(Math.random() * 90) + 10;
      b = Math.floor(Math.random() * 90) + 10;
    }
    const a1 = a >= 10 ? Math.floor(a/10)*10 : a;
    const a2 = a >= 10 ? a - a1 : 0;
    const b1 = b >= 10 ? Math.floor(b/10)*10 : b;
    const b2 = b >= 10 ? b - b1 : 0;
    setQuestion({ a, b, answer: a*b, hint: { a1, a2, b1, b2, parts: [
      { label: a1+'x'+b1, value: a1*b1 },
      { label: a1+'x'+b2, value: a1*b2 },
      { label: a2+'x'+b1, value: a2*b1 },
      { label: a2+'x'+b2, value: a2*b2 }
    ]}});
    setTimeout(() => inputRef.current && inputRef.current.focus(), 100);
  };

  const addXP = async (pts) => {
    await fetch('/api/xp', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ user, subject: 'matematik', points: pts }) });
    setXp(prev => ({ today: prev.today+pts, week: prev.week+pts, year: prev.year+pts }));
    setXpGained(pts);
    setShowXpFloat(true);
    setTimeout(() => setShowXpFloat(false), 1000);
  };

  const check = async () => {
    if (!question || answer === '') return;
    if (parseInt(answer) === question.answer) {
      setFeedback('correct');
      await addXP(showHint ? 1 : difficulty === 'svær' ? 5 : 3);
      setStreak(s => s+1);
    } else {
      setFeedback('wrong');
      setStreak(0);
    }
  };

  return (
    <div style={s.page}>
      {showXpFloat && <div style={s.xpFloat}>+{xpGained} XP ⭐</div>}
      <div style={s.header}>
        <button style={s.back} onClick={() => navigate('/'+user)}>← Tilbage</button>
        <h1 style={{ fontFamily: 'Bangers, cursive', fontSize: '2rem', letterSpacing: '3px', color: 'var(--accent)', flex: 1, textShadow: '0 0 15px rgba(249,199,79,0.5)' }}>🔢 Matematik</h1>
      </div>
      <div style={s.xpRow}>
        <span>I dag: <strong style={{ color: 'var(--accent)' }}>{xp.today} XP</strong></span>
        <span>Uge: <strong style={{ color: 'var(--accent)' }}>{xp.week} XP</strong></span>
        <span>År: <strong style={{ color: 'var(--accent)' }}>{xp.year} XP</strong></span>
      </div>
      <div style={s.diffTabs}>
        {[['simpel', 'Simpel', '1×10'], ['svær', 'Svær', '10×10']].map(([key, label, sub]) => (
          <button key={key} onClick={() => setDifficulty(key)} style={{ background: difficulty === key ? 'var(--accent)' : 'transparent', color: difficulty === key ? '#060b14' : 'var(--text-muted)', border: 'none', borderRadius: '12px', padding: '0.6rem 1.2rem', fontSize: '0.95rem', fontWeight: 800, cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            {label}
            <span style={{ fontSize: '0.7rem', opacity: 0.7 }}>{sub}</span>
          </button>
        ))}
      </div>
      <div style={{ display: 'flex', gap: '0.4rem' }}>
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} style={{ width: 14, height: 14, borderRadius: '50%', background: i < streak ? 'var(--accent)' : 'rgba(255,255,255,0.1)', boxShadow: i < streak ? '0 0 8px var(--accent)' : 'none' }} />
        ))}
      </div>
      {question && (
        <div style={s.card}>
          <div style={s.question}>{question.a} × {question.b} = ?</div>
          {feedback === null && (
            <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
              <input ref={inputRef} style={s.input} type="number" value={answer} onChange={e => setAnswer(e.target.value)} onKeyDown={e => e.key === 'Enter' && check()} placeholder="?" />
              <button style={s.checkBtn} onClick={check}>Tjek ✓</button>
            </div>
          )}
          {feedback === 'correct' && (
            <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '1rem', alignItems: 'center' }}>
              <div style={{ fontSize: '2rem', fontFamily: 'Bangers, cursive', color: 'var(--green)', textShadow: '0 0 15px rgba(0,245,160,0.5)' }}>
                🎉 Rigtigt! +{showHint ? 1 : difficulty === 'svær' ? 5 : 3} XP
                {streak >= 3 && <span style={{ display: 'block', color: 'var(--accent)' }}>🔥 {streak} i træk!</span>}
              </div>
              <button style={s.nextBtn} onClick={loadQuestion}>Næste spørgsmål →</button>
            </div>
          )}
          {feedback === 'wrong' && (
            <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '1rem', alignItems: 'center' }}>
              <div style={{ fontSize: '2rem', fontFamily: 'Bangers, cursive', color: 'var(--red)' }}>❌ Prøv igen!</div>
              <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                <input style={s.input} type="number" value={answer} onChange={e => setAnswer(e.target.value)} onKeyDown={e => e.key === 'Enter' && check()} placeholder="?" autoFocus />
                <button style={s.checkBtn} onClick={check}>Tjek ✓</button>
              </div>
            </div>
          )}
          {!showHint && feedback !== 'correct' && (
            <button style={s.hintBtn} onClick={() => setShowHint(true)}>💡 Vis hint (1 XP i stedet for {difficulty === 'svær' ? 5 : 3})</button>
          )}
          {showHint && (
            <div style={s.hintBox}>
              <div style={{ color: 'var(--blue)', fontFamily: 'Bangers, cursive', fontSize: '1.4rem', marginBottom: '1.25rem', letterSpacing: '2px' }}>Opdel tallene!</div>
              <div style={{ fontSize: '1.05rem', lineHeight: 2, textAlign: 'center', flexWrap: 'wrap', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '0.3rem' }}>
                <span style={{ color: 'var(--accent)', fontWeight: 900 }}>{question.a}</span>
                <span style={{ color: 'var(--text-muted)' }}>x</span>
                <span style={{ color: 'var(--accent)', fontWeight: 900 }}>{question.b}</span>
                <span style={{ color: 'var(--text-muted)' }}>=</span>
                <span style={{ color: 'var(--blue)', fontWeight: 900 }}>({question.hint.a1} + {question.hint.a2})</span>
                <span style={{ color: 'var(--text-muted)' }}>x</span>
                <span style={{ color: 'var(--green)', fontWeight: 900 }}>({question.hint.b1} + {question.hint.b2})</span>
                <span style={{ color: 'var(--text-muted)' }}>=</span>
                <span style={{ color: 'var(--text-muted)', fontWeight: 700 }}>
                  {question.hint.parts.filter(p => p.value > 0).map((p, i, arr) => {
                    const parts = p.label.split('x');
                    return (
                      <span key={i}>
                        <span style={{ color: 'var(--blue)' }}>{parts[0]}</span>
                        <span style={{ color: 'var(--text-muted)' }}> x </span>
                        <span style={{ color: 'var(--green)' }}>{parts[1]}</span>
                        {i < arr.length - 1 && <span style={{ color: 'var(--text-muted)' }}> + </span>}
                      </span>
                    );
                  })}
                </span>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
